import { Storage } from 'react-jhipster';

export const LOCAL_STORAGE_KEYS = {
  PENDING_AUTHENTICATION: 'PENDING_AUTHENTICATION_PUB',
  PENDING_NIAS_NAVBAR: 'PENDING_NIAS_NAVBAR',
  ACCESSIBILITY_CONTRAST: 'ACCESSIBILITY_CONTRAST',
  ACCESSIBILITY_DYSLEXIA: 'ACCESSIBILITY_DYSLEXIA',
  ACCESSIBILITY_FONT_SIZE: 'ACCESSIBILITY_FONT_SIZE',
  CASE_PREVIEW_RETURN: 'CASE_PREVIEW_RETURN',
  CASE_SUBMISSION_IN_PROGRESS: 'CASE_SUBMISSION_IN_PROGRESS',
  FILE_OPENED_FROM: 'FILE_OPENED_FROM',
  AMENDMENT_FROM: 'AMENDMENT_FROM',
  KEYCLOAK_LOCAL_LOGOUT: 'KEYCLOAK_LOCAL_LOGOUT',
};

export const SESSION_STORAGE_KEYS = {
  FROM_URL: 'FROM_URL',
};

export const clearLocalStorageExceptPendingAuthentication = () => {
  Object.values(LOCAL_STORAGE_KEYS)
    .filter(key => key !== LOCAL_STORAGE_KEYS.PENDING_AUTHENTICATION)
    .filter(key => key !== LOCAL_STORAGE_KEYS.KEYCLOAK_LOCAL_LOGOUT)
    .forEach(value => Storage.local.remove(value));
};

const cleanLocalStorage = () => {
  const keys = Object.keys(localStorage);

  keys.forEach((key) => {
    if (key !== LOCAL_STORAGE_KEYS.KEYCLOAK_LOCAL_LOGOUT) {
      localStorage.removeItem(key);
    }
  });
}
export default cleanLocalStorage
